interface UploadedFile {
  file_name: string;
  [key: string]: unknown;
}

/**
 * Extracts file names from a JSON string of uploaded files
 * @param uploadedFiles JSON string containing file information
 * @returns File names with line breaks or a message if no files
 */
export function extractFileNames(
  uploadedFiles: string | null | undefined
): string[] {
  if (!uploadedFiles) {
    return [];
  }

  try {
    const files = JSON.parse(uploadedFiles);
    if (!Array.isArray(files) || files.length === 0) {
      return [];
    }

    // Return file names with HTML line breaks
    return files.map((file: UploadedFile) => file.file_name);
  } catch {
    return [];
  }
}
